(function () {
  if(document.body.id !== 'lp') return false

  //メインビジュアルの表示高さを調整
  const topMV = document.querySelector('.js-lp-mv') 
  if(topMV) {
    let currentWidth = 0;

    function resize() {
      if (currentWidth == window.innerWidth) {
        return
      }
      topMV.style.height = window.innerHeight +'px';
      currentWidth = window.innerWidth
    }
  
    window.addEventListener('resize', resize)
    resize()
  
    // startSlide()
  
    const fraction =  document.querySelector('.js-custom-fraction')
    const pagination =  document.querySelector('.js-lp-mv-pagination')
  
    fraction.classList.add('is-show')
    pagination.classList.add('is-show')
    // function startSlide() {
    //   // mvSwiper.slideNext()
    //   // mvSwiper.autoplay.start()
    //   // mvSwiper.allowTouchMove = true
    // }
  
    const slideContainer = document.querySelector('.js-lp-mv-slider')
    slideContainer.classList.add('swiper')
    const slideWrapper = slideContainer.querySelector('.wrapper')
    slideWrapper.classList.add('swiper-wrapper')
    const slide = slideWrapper.querySelectorAll('.slide')
    
    const images = slideWrapper.querySelectorAll('img')
    objectFitImages(images)
  
    for (var i = 0; i < slide.length; i++) {
      slide[i].classList.add('swiper-slide')
    }
  
    let mvSwiper = new Swiper('.js-lp-mv-slider', {
      effect: 'fade',
      speed: 2000,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      pagination: {
        el: ".js-lp-mv-pagination",
        clickable: true
      },
      on: {
        init: function () {
          let slideNum = []
          const slideLength = document.querySelectorAll('.js-lp-mv-slider .swiper-slide').length
          if (this.loopedSlides) {
            for (let i = 0; i < slideLength; i++) {
              slideNum.push(document.querySelector('.js-lp-mv-slider').getElementsByClassName('swiper-slide')[i].dataset.swiperSlideIndex)
              maxSlideNum = Math.max(...slideNum) + 1
            }
          } else {
            maxSlideNum = slideLength;
          }
          document.querySelector('.js-lp-mv-max').innerHTML = ( '00' + maxSlideNum ).slice( -2 )
          document.querySelector('.js-lp-mv-current').innerHTML = '01';
        },
        transitionStart: function () {
          thisSlideIndex = [].slice.call(document.querySelector('.swiper-pagination').querySelectorAll('.swiper-pagination-bullet')).indexOf(document.querySelector('.swiper-pagination-bullet-active')) + 1;
          document.querySelector('.js-lp-mv-current').innerHTML = ( '00' + thisSlideIndex ).slice( -2 );
        },
      }
    })
  
    mvSwiper.on('slideChangeTransitionStart', startAnimation)
    function startAnimation() {
      const swiper = document.querySelector('.js-lp-mv-slider')
      swiper.classList.add('is-animation')
      mvSwiper.off('slideChangeTransitionStart', startAnimation)
    }
  }
  
}());
